import { CheckOne } from "@icon-park/svg";
import { useIsMobile } from "@justhome/common/hooks";
import { Icon } from "@justhome/react-ui";
import clsx from "clsx";
import Image from "next/image";
import { ChangeEvent, FC, InputHTMLAttributes } from "react";
import styles from "./OptionCard.module.scss";
import OptionCardInfo from "./OptionCardInfo";

export type OptionCardProps = {
  name?: string;
  value?: any;
  infoText?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  image?: string;
} & Omit<InputHTMLAttributes<HTMLInputElement>, "size">;

const OptionCard: FC<OptionCardProps> = ({
  infoText,
  className,
  children,
  type = "radio",
  image,
  ...props
}) => {
  const isMobile = useIsMobile();
  const content = (
    <span className={clsx("text-center", styles.content)}>{children}</span>
  );
  return (
    <label className={clsx("w-full flex", className)}>
      <input
        type={type}
        className="h-none w-none absolute overflow-hidden opacity-0 peer"
        {...props}
      />

      <span
        className={clsx(
          "grow relative flex flex-col cursor-pointer text-h3 transition-all border border-neutral-50 rounded-s hover-desktop:border-primary-825 peer-focus-visible:shadow-focus px-3xs peer-checked:bg-primary-800 peer-checked:text-neutral-0 peer-checked:border-primary-800  hover-desktop:text-primary-800 hover-desktop:peer-checked:bg-primary-825 group",
          styles.label,
          {
            "py-s m:py-3xs": image,
            "py-s m:py-s": !image,
          },
        )}
      >
        <span
          className={clsx("flex justify-between", {
            "items-center": !image,
          })}
        >
          <span className="w-m flex-none">
            <span className={clsx("hidden", styles.icon)}>
              <Icon
                icon={CheckOne}
                theme="multi-color"
                size={isMobile ? 22 : 28}
                fill={["#ffffff", "#ffffff", "currentColor", "currentColor"]}
              />
            </span>
          </span>
          {image && <Image src={image} width="64" height="64" alt="" />}
          {!image && content}
          <span className="w-m flex-none">
            {infoText && <OptionCardInfo>{infoText}</OptionCardInfo>}
          </span>
        </span>
        {image && <span className="flex justify-center mt-2xs">{content}</span>}
      </span>
    </label>
  );
};

export default OptionCard;
